<!-- 拖拽组件 -->
<template>
  <div class="dragIndex" :style="{'width':itemWidth+'px','height':itemHeight+'px','left':isWeb==1?left+(-50)+'px':left+'px','top':top+'px'}" ref="div">
    <div class="btn df-center catelogue-btn" @click='handleCatelogue'>目录</div>
    <div v-if='source==0 && isWeb!=1' class="btn df-center share-btn" @click='handleShare'>分享</div>
    <div v-if='source==0 || isWeb==1' class="btn df-center download-btn" @click='handleDownLoad'>下载</div>
  </div>
</template>
<script>
  export default {
    name: 'dragIndex',
    props: {
      source:{
        type: String,
        default: '0',
      },
      isWeb:{
        type: String,
        default: '0',
      },
      itemWidth: {
        type: Number,
        default: 110,
      },
      itemHeight: {
        type: Number,
        default: 165,
      },
      gapWidth: {
        type: Number,
        default: -10,
      },
      coefficientHeight: {
        type: Number,
        default: 0.65,
      },
    },
    created() {
      this.clientWidth = document.documentElement.clientWidth
      this.clientHeight = document.documentElement.clientHeight
      this.left = this.clientWidth - this.itemWidth - this.gapWidth
      this.top = this.clientHeight * this.coefficientHeight
    },
    mounted() {
      this.$nextTick(() => {
        const div = this.$refs.div
        div.addEventListener('touchstart', (e) => {
          e.stopPropagation()
          div.style.transition = 'none'
        })
        div.addEventListener(
          'touchmove',
          (e) => {
            e.stopPropagation()
            if (e.targetTouches.length === 1) {
              let touch = event.targetTouches[0]
              this.left = touch.clientX - this.itemWidth / 2
              this.top = touch.clientY - this.itemHeight / 2
            }
          },
          false
        )
        div.addEventListener('touchend', (e) => {
          e.stopPropagation()
          div.style.transition = 'all 0.3s'
          if (this.left > this.clientWidth / 2) {
            this.left = this.clientWidth - this.itemWidth - this.gapWidth
          } else {
            this.left = this.gapWidth
          }
          if (this.top <= 36) {
            this.top = 36 + this.gapWidth
          } else {
            let bottom = this.clientHeight - 50 - this.itemHeight - this.gapWidth
            console.log(bottom, this.top)
            if (this.top >= bottom) {
              this.top = bottom
            }
          }
        })
      })
    },

    methods: {
      handleShare(){
        this.$emit('handleShare')
      },
      handleDownLoad(){
        this.$emit('handleDownLoad')
      },
      handleCatelogue(){
        this.$emit('handleCatelogue')
      }
    },
    data() {
      return {
        timer: null,
        currentTop: 0,
        clientWidth: 0,
        clientHeight: 0,
        left: 0,
        top: 0,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .dragIndex {
    // box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    // border-radius: 50%;
    color: #666666;
    z-index: 2000;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 20vw;
    background-size: 100%;
    .btn{
      width: 50px;
      height: 50px;
      opacity: 0.9;
      background: #1c91ff;
      border-radius: 100px;
      box-shadow: 0px 2px 6px 0px rgba(28,145,255,0.49); 
      font-size: 15px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #ffffff;
    }
    .share-btn{
      margin: 10px 0px;
    }
    .download-btn{
    }
  }
</style>